module.exports = __webpack_public_path__ + "img/empty-img.f97bdcf7.png";